module.exports = __webpack_public_path__ + "static/media/fisher-logo-01.ac77a555.svg";